import React from "react";
import GridContainer from "../../../@jumbo/components/GridContainer";
import PageContainer from "../../../@jumbo/components/PageComponents/layouts/PageContainer";
import IntlMessages from "../../../@jumbo/utils/IntlMessages";

import Grid from "@material-ui/core/Grid";
import Divider from "@material-ui/core/Divider";

import PointsBankContainer from "@jumbo/Dashboards/Point/PointsBankContainer";

const breadcrumbs = [
  { label: <IntlMessages id={"sidebar.main"} />, link: "/" },
  { label: <IntlMessages id={"pages.pointBank"} />, isActive: true },
];

const PointBank = () => {
  return (
    <PageContainer
      heading={<IntlMessages id="pages.pointBank" />}
      breadcrumbs={breadcrumbs}
    >
      <GridContainer>
        <Grid item xs={12}>
          <div style={{ marginBottom: 10 }}>
            <IntlMessages id="pages.pointBank.description" />
          </div>
          <Divider />
          <div style={{ marginTop: 24 }}>
            <PointsBankContainer />
          </div>
        </Grid>
      </GridContainer>
    </PageContainer>
  );
};

export default PointBank;